import { ReactNode } from 'react';

export const getSlidesTranslationValue = (slidePosition: number) => {
    return slidePosition === 0 ? '0' : `-${slidePosition}00`;
};

export type GetSlideTranslateXProps = {
    gap: string;
    slidePosition: number;
    translationValue: string;
    snapToEndPosition?: string;
    customTranslate?: string;
};

export const getSlideTranslateX = ({
    gap,
    slidePosition,
    translationValue,
    snapToEndPosition,
    customTranslate,
}: GetSlideTranslateXProps) => {
    if (snapToEndPosition) {
        return `translateX(${snapToEndPosition})`;
    }
    if (customTranslate) {
        return `translateX(${customTranslate})`;
    }
    if (slidePosition === 0 || gap === '') {
        return `translateX(${translationValue}%)`;
    }
    return `translateX(calc(${translationValue}% - (${gap} * ${slidePosition})))`;
};

export const getPrevItem = (
    currentIndex: number,
    items: ReactNode[] | number[],
) => (items.length + currentIndex - 1) % items.length;

export const getNextItem = (
    currentIndex: number,
    items: ReactNode[] | number[],
) => (currentIndex + 1) % items.length;

export const isLastItem = (
    currentIndex: number,
    items: ReactNode[] | number[],
) => currentIndex === items.length - 1;

export const getIsEndOfCarousel = (
    currentIndex: number,
    items: ReactNode[] | number[],
    itemsToShow?: number,
) => itemsToShow && currentIndex === items.length - itemsToShow;
